import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import TestimonialContent from "./TestimonialContent";
export default class Testimonial extends Component {
  render() {
    let id = this.props.match.params.id;
    return (
      <div class="wrapper">
        <Navbar />
        <Mainmenu />
        <TestimonialContent id={id} />
        <Footer />
      </div>
    );
  }
}
